<template>
	<div class="center-content" :style="style">
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { CSSProperties } from 'vue';

export default {
	props: {
		width: {
			type: String,
			required: false,
			default: undefined,
		},
		height: {
			type: String,
			required: false,
			default: undefined,
		},
	},
	setup(props) {
		const style = computed<CSSProperties>(() => ({
			width: props.width,
			height: props.height,
		}));
		return {
			style,
		};
	},
};
</script>

<style scoped>
.center-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>
